var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5556 18.25H17.5667M18 14.5H18.6667C19.7021 14.5 20.2198 14.5 20.6282 14.6902C21.1727 14.944 21.6053 15.4308 21.8309 16.0433C22 16.5028 22 17.0851 22 18.25C22 19.4149 22 19.9972 21.8309 20.4567C21.6053 21.0692 21.1727 21.556 20.6282 21.8097C20.2198 22 19.7021 22 18.6667 22H5.33333C4.29791 22 3.7802 22 3.37181 21.8097C2.82731 21.556 2.3947 21.0692 2.16916 20.4567C2 19.9972 2 19.4149 2 18.25C2 17.0851 2 16.5028 2.16916 16.0433C2.3947 15.4308 2.82731 14.944 3.37181 14.6902C3.7802 14.5 4.29791 14.5 5.33333 14.5H6M12 15.75V2M12 15.75L8.66667 12M12 15.75L15.3333 12",
    stroke: "#989898",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.df6b6b8a247151571a8f5d4deea6aae7.svg";
export { ForwardRef as ReactComponent };